import React, { useEffect, useState } from "react";
import { Form, Formik, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getTeamList } from "services/branchServices";
import { createBranchConsultant } from "services/branchServices";
import { toast, Toaster } from "react-hot-toast";

import { useLocation } from "react-router-dom";
import TextField from "common/formUI/textfield";
import RichTextbox from "common/formUI/richTextbox";
import UploadFileField from "common/formUI/uploadfileField";
import { CommonButton } from "components/common/button/Button";
import * as Yup from "yup";
import { customStyle, inputLabelStyles } from "common/constants/constants";
import Loader from "components/common/loader/Loader";
import { TailSpin } from "react-loader-spinner";
import { updateTeam } from "services/branchServices";
import { useTranslation } from "react-i18next";
const CreateNewMember = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const isfetching = false;
  const { pathIds, item = {} } = location.state;
  const branchName = localStorage.getItem("branchName");
  const [isLoading, setIsLoading] = useState(false);
  const { teamMemberId: params = "" } = useParams();
  const findObjectKeyLength = (object, key) => {
    return Object.keys(object).length > 0 && object[key];
  };

  const initialValues = {
    firstName: findObjectKeyLength(item, "firstName") ? item?.firstName : "",
    lastName: findObjectKeyLength(item, "lastName") ? item?.lastName : "",
    profilePicture: findObjectKeyLength(item, "consultantProfileImage")
      ? { name: item?.consultantProfileImage }
      : null,
    description: findObjectKeyLength(item, "description")
      ? item?.description
      : "",
    education: findObjectKeyLength(item, "education") ? item?.education : "",
  };

  const { teamMemberId = "" } = useParams();

  let dataFilters = {
    firstName: "",
    lastName: "",
    description: "",
    education: "",
  };

  const postBranchData = async (values) => {
    setIsLoading(true);
    const { profilePicture, education, firstName, lastName, description } =
      values;

    let formData = new FormData();
    formData.append("profilePicture", profilePicture);
    formData.append("education", education);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("description", description);
    const result = await createBranchConsultant(formData, pathIds);

    if (result.success) {
      navigate("/branch-detail/teams", { state: { pathIds } });
      setShow(true);
      getTeamList();
    } else {
      toast.error(result?.data?.message);
    }
    setIsLoading(false);
  };

  const updateTeamData = async (values, teamMemberId) => {
    setIsLoading(true);
    const { profilePicture, education, firstName, lastName, description } =
      values;
    let formData = new FormData();
    formData.append("profilePicture", profilePicture);
    formData.append("education", education);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("description", description);
    const result = await updateTeam(
      pathIds,
      teamMemberId,
      dataFilters,
      formData
    );
    if (result.success) {
      navigate(`/branch-detail/teams`, { state: { pathIds } });
      setShow(true);
      getTeamList();
    } else {
      toast.error(result?.message);
    }
    setIsLoading(false);
  };

  const FILE_SIZE = 30 * 1024 * 1024;
  const SUPPORTED_FORMATS_IMAGE = ["image/jpg", "image/jpeg", "image/png"];

  const validate = Yup.object().shape({
    firstName: Yup.string()
      //.matches(/^[a-zA-ZöäüßÖÄÜ\s]+$/, "Invalid Name")
      .max(30, "Must be less than 30 characters")
      .required(t("required")),

    lastName: Yup.string()
      //.matches(/^[a-zA-ZöäüßÖÄÜ\s]+$/, "Invalid LastName")
      .max(30, "Must be less than 30 characters")
      .required(t("required")),

    description: Yup.string()
      //.matches(/^[a-zA-Z0-9öäüßÖÄÜ,.\s]+$/, "Invalid Description")
      .required(t("required")),

    education: Yup.string().test(
      "required",
      t("required"),
      (value) => value !== "<p><br></p>"
    ),

    profilePicture: Yup.mixed()
      .required(t("required"))
      .test("fileFormat", t("unsupported-format"), (value) => {
        let isImgFormat = value && value["type"]?.split("/")[0] === "image";
        return isImgFormat
          ? value && SUPPORTED_FORMATS_IMAGE.includes(value.type)
          : true;
      })
      .test("fileSize", t("invalid-file-size"), (value) => {
        let isImgFormat = value && value["type"]?.split("/")[0] === "image";
        return isImgFormat ? value && value.size <= FILE_SIZE : true;
      }),
  });

  const handleSubmit = async (values, { setFieldError }) => {
    if (params) {
      await updateTeamData(values, teamMemberId);
      return;
    }
    await postBranchData(values);
    return;
  };
  return (
    <>
      <Toaster />

      <div className="custom-breadcrumbs mx-5 px-2">
        <span
          className="breadcrumbs-item "
          onClick={() => {
            navigate("/branch-detail");
          }}
        >
          {t("branches")}
        </span>
        <span
          className="breadcrumbs-item "
          onClick={() => {
            navigate("/branch-detail");
          }}
        >
          {" "}
          {branchName}
        </span>
      </div>
      <div className="payment-info-container" style={{ marginTop: "-35px" }}>
        {params ? (
          <p className="page-title">{t("update-member")}</p>
        ) : (
          <p className="page-title">{t("create-new-member")}</p>
        )}

        <hr />
        {!isfetching ? (
          <Formik
            initialValues={initialValues}
            validationSchema={validate}
            enableReinitialize={true}
            onSubmit={(values, { setFieldError }) =>
              handleSubmit(values, { setFieldError })
            }
          >
            {(formik) => {
              return (
                <Form onSubmit={formik.handleSubmit}>
                  <Row className="branch-details upload-file">
                    <Col lg={6} xs={12}>
                      <div>
                        <p
                          style={{ fontWeight: "600", fontSize: "0.85rem" }}
                          className="my-3"
                        >
                          Name *
                        </p>
                        <div
                          className="d-flex flex-lg-nowrap justify-content-between flex-wrap w-100"
                          style={{ minHeight: "85px" }}
                        >
                          <TextField
                            id="firstName"
                            name="firstName"
                            varient="filled"
                            label={t("first-name")}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            sx={{
                              ...customStyle,
                              width: "46.375%",
                            }}
                            InputLabelProps={{
                              sx: inputLabelStyles,
                            }}
                          />

                          <TextField
                            id="lastName"
                            name="lastName"
                            varient="filled"
                            label={t("last-name")}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            sx={{
                              ...customStyle,
                              width: "46.375%",
                            }}
                            InputLabelProps={{
                              sx: inputLabelStyles,
                            }}
                          />
                        </div>
                      </div>

                      <br />
                      <div>
                        <div className="d-flex mt-0 mb-3">
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "0.85rem",
                              marginTop: "8px",
                            }}
                          >
                            {t("description")} *
                          </p>
                          <p style={{ marginTop: "8px" }}>
                            {t("team-mmember-description-label")}
                          </p>
                        </div>

                        <TextField
                          id="description"
                          name="description"
                          varient="filled"
                          placeholder={t("team-member-description-placeholder")}
                          formik={formik}
                          multiline
                          rows={6}
                          maxRows={8}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          sx={{
                            ...customStyle,
                            width: "100%",
                            height: "162px !important",
                          }}
                          InputLabelProps={{
                            sx: inputLabelStyles,
                          }}
                        />
                      </div>
                    </Col>
                    <div style={{ width: "4%" }}></div>
                    <Col lg={5} xs={12}>
                      <div>
                        <p
                          style={{ fontWeight: "600", fontSize: "0.85rem" }}
                          className="my-3"
                        >
                          {t("upload-profile-photo")} *
                        </p>
                        <div
                          className="upload-feild-container"
                          style={{ width: "60%" }}
                        >
                          <UploadFileField
                            name="profilePicture"
                            formik={formik}
                            fullWidth={true}
                            extension="image/jpeg,image/png"
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          margin: "40px 0 20px 0 !important",
                          maxWidth: "500px",
                          transform: "translateY(-9px)",
                        }}
                      >
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: "0.85rem",
                            margin: "40px 0 20px 0 !important",
                          }}
                          className="mt-5 mb-3"
                        >
                          {t("education")} *
                        </p>

                        <RichTextbox
                          id="education"
                          name="education"
                          label={t("education")}
                          controls={["bulletList"]}
                          formik={formik}
                        />
                      </div>
                      <div className="save-button-container d-flex justify-content-between align-items-end w-100">
                        <p>{t("fields-are-mandatory")}</p>
                        <CommonButton
                          title={
                            isLoading ? (
                              <TailSpin
                                height="20"
                                width="20"
                                color="#ffff"
                                radius="1"
                                visible={true}
                              />
                            ) : (
                              t("save")
                            )
                          }
                          disabled={isLoading ? true : false}
                          border="none"
                          borderRadius="5px"
                          type="submit"
                        />
                      </div>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        ) : (
          <Loader />
        )}
      </div>
    </>
  );
};

export default CreateNewMember;
